module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grrz-dialog-wrap"
  }, [((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && _vm.rightUsed[11]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("个人认证")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-grrz.png")
    }
  })])]) : ((_vm.cvipMes.cvipstate === 1 || _vm.cvipMes.cvipstate === 10) && !_vm.rightUsed[11]) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title2,
      "btnTxt": _vm.btnTxt2
    },
    on: {
      "btnClick": function($event) {
        return _vm.certification()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("个人认证")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-grrz.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("会员可以免费进行芝麻认证，核实自己的真实身份，获得更高的信用，更容易博得企业信赖！")])]), _vm._v(" "), _c('div', {
    staticClass: "grrz-bg"
  }, [_c('img', {
    staticClass: "grrz-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-grrz.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ffccb154"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/GrrzDialog.vue
// module id = ooJt
// module chunks = 1